import React, { useEffect, useState } from "react";

/**
 * Shows a small banner when a new service-worker version is waiting to take over.
 */
export default function SwUpdateBanner() {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let disposed = false;
    let registration;
    let updateOnFocus;
    let interval;
    navigator.serviceWorker.getRegistration().then((reg) => {
      if (disposed) return;
      registration = reg;
      if (!reg) return;
      reg.update().catch(() => {});
      const onUpdate = () => {
        if (reg.waiting) setWaiting(reg.waiting);
      };
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "installed" && navigator.serviceWorker.controller) {
            setWaiting(reg.waiting || installing);
          }
        });
      });
      onUpdate();
      updateOnFocus = () => reg.update().catch(() => {});
      window.addEventListener("focus", updateOnFocus);
      interval = window.setInterval(updateOnFocus, 60000);
    });
    let refreshed = false;
    const onControllerChange = () => {
      if (!refreshed) { refreshed = true; window.location.reload(); }
    };
    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
    return () => {
      disposed = true;
      if (registration && updateOnFocus) window.removeEventListener("focus", updateOnFocus);
      if (interval) window.clearInterval(interval);
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
    };
  }, []);

  if (!waiting) return null;
  const refresh = () => {
    try { waiting.postMessage({ type: "SKIP_WAITING" }); } catch {}
  };

  return (
    <div
      data-testid="sw-update-banner"
      style={{
        position: "fixed",
        bottom: 50,
        left: "50%",
        transform: "translateX(-50%)",
        background: "#000",
        border: "1px solid #ffde16",
        color: "#ffde16",
        borderRadius: 999,
        padding: "10px 18px",
        fontSize: "0.85em",
        zIndex: 9000,
        display: "flex",
        alignItems: "center",
        gap: 12,
        boxShadow: "0 6px 20px rgba(255, 222, 22, 0.2)",
      }}
    >
      <img src="/bolt.png" alt="" className="inline-block h-4 w-4 align-middle" /> a new version is available
      <button className="xs-btn primary" style={{ padding: "6px 14px", minHeight: 32 }} onClick={refresh}>
        refresh
      </button>
    </div>
  );
}
